module.exports = __webpack_public_path__ + "img/login-bg-4.f1817f33.jpg";